"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCardContentProps = exports.CardContentBlock = void 0;
var _react = _interopRequireDefault(require("react"));
const getCardContentProps = customCardContentProps => {
  const defaultCardContentProps = {
    notYetImplementedDoNotUse: ''
  };
  return customCardContentProps || defaultCardContentProps;
};
exports.getCardContentProps = getCardContentProps;
const CardContentBlock = () => {
  return /*#__PURE__*/_react.default.createElement("div", null, "CARD CONTENT NOT YET IMPLEMENTED DO NOT USE!");
};
exports.CardContentBlock = CardContentBlock;